import DocumentsRowHeader from './document-row-header';
import DocumentRow from './document-row';
import { ApplicationDocument } from '../../../../../../hoc/new-application/types';
import { DocumentsItemsTypes } from '../../types';

import cn from '../../../styles.module.css';

const DocumentsItems = ({
  onGroupSelect,
  documents,
  applicationId,
  cof,
  setSelected,
  search,
  setSelectedDocument,
  setRenamePopupVisible,
  status,
  renameAvailable,
}: DocumentsItemsTypes) => (
  <div className={cn.documentsItemsWrapper}>
    <DocumentsRowHeader
      onGroupSelect={onGroupSelect}
      documents={documents as ApplicationDocument[]}
      documentsSelected={documents?.filter((item) => item.isSelected).length}
    />
    {documents?.map((item) => (
      <DocumentRow
        key={item.id}
        document={item}
        cof={cof}
        setSelected={(checked) =>
          setSelected({ id: item.id, selected: checked })
        }
        applicationId={applicationId}
        search={search}
        setSelectedDocument={setSelectedDocument}
        setRenamePopupVisible={setRenamePopupVisible}
        status={status}
        renameAvailable={renameAvailable}
      />
    ))}
  </div>
);

export default DocumentsItems;
